<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit" class="login-form">
    <v-text-field
      outlined
      :placeholder="$t('email')"
      v-model="form.email"
      :rules="[rules.required('email')]"
      :disabled="loading"    
    ></v-text-field>

    <v-text-field
      outlined
      :placeholder="$t('password')"
      v-model="form.password"
      :append-icon="passwordHidden ? 'visibility_off' : 'visibility'"
      @click:append="() => (passwordHidden = !passwordHidden)"
      :type="passwordHidden ? 'password' : 'text'"
      :disabled="loading"
      :loading="loading"
      :rules="[rules.required('password')]"
      
    ></v-text-field>
<!--  -->
    <v-btn
      type="submit"
      :loading="loading" 
      :disabled="loading"
      block
      x-large
      color="primary"
    >
      {{ $t('sign_in') }}
    </v-btn>
<!--   -->



    <!-- <div class="text-center mt-5">
      <router-link class="info--text" :to="{ name: 'password' }">{{ $t('M00006') }}</router-link>
    </div> -->
  </v-form>
</template>

<script>
import vForm from '@/mixins/vForm'
export default {
  mixins: [vForm],

  data: () => ({
    passwordHidden: true,
    form: {
      email: null,
      password: null
    }
  }),

  created() {},

  methods: {
    async submit() {
      let loader = this.$loading.show();
      
      if (!this.$refs.form.validate()) {
        loader.hide();
        return;
      }
     
 
      await axios.post('/api/auth/login', this.form)
        .then(res => res.data)
          .then(res => {
              if(res.code === 200) {
                 
                  console.log(res.data)
                  this.$emit('success', res.data)
              }
              else {
                this.$toastr.e(res.data.message);
                
              }
          })
          .catch((err) => {
            if (err.response && err.response.status === 401) {
          // Handle validation errors with a 422 status code
          this.$toastr.e("Wrong email or password")
   
     } else {
      // Handle other errors
      this.$toastr.e("Contact Admin");
    }
           
          })
          .finally(()=>{
            loader.hide();
          });      
      
    },
    
  }
};
</script>